module.exports = __webpack_public_path__ + "static/media/magpieBanner_sm1.236258f1.png";